import { Avatar, Chip, ListItem, Button } from "@mui/material";
import { Box } from "@mui/system";
import PageRoutes from "../Config/PageRoutes";
import { Link, useParams } from "react-router-dom";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import { useRef, useState, useEffect } from "react";


import BovineIcon from "../Assets/Bovine.svg";
import CarrotIcon from "../Assets/Carrots.svg";
import CauliflowerIcon from "../Assets/Cauliflower.svg";
import DriedBeansIcon from "../Assets/Driedbeans.svg";
import KiwiIcon from "../Assets/kiwi.svg";
import OnionIcon from "../Assets/onions.svg";
import OrangeIcon from "../Assets/oranges.svg";
import PearIcon from "../Assets/pears.svg";
import PotatoIcon from "../Assets/potatoes.svg";
import PoultryIcon from "../Assets/Poultry.svg";
import RiceIcon from "../Assets/Rice.svg";
import RyeIcon from "../Assets/Rye.svg";

const CommoditiesMenu = () => {
  const commodities = [
    { name: "Carrots", icon: CarrotIcon, activeIcon: CarrotIcon },
    { name: "Cauliflowers", icon: CauliflowerIcon, activeIcon: CauliflowerIcon },
    { name: "Kiwi fruits", icon: KiwiIcon, activeIcon: KiwiIcon },
    { name: "Onions", icon: OnionIcon, activeIcon: OnionIcon },
    { name: "Oranges", icon: OrangeIcon, activeIcon: OrangeIcon },
    { name: "Pears", icon: PearIcon, activeIcon: PearIcon },
    { name: "Potatoes", icon: PotatoIcon, activeIcon: PotatoIcon },
    { name: "Dried beans", icon: DriedBeansIcon, activeIcon: DriedBeansIcon },
    { name: "Rice", icon: RiceIcon, activeIcon: RiceIcon },
    { name: "Rye", icon: RyeIcon, activeIcon: RyeIcon },
    { name: "Bovine liver", icon: BovineIcon, activeIcon: BovineIcon },
    { name: "Poultry fat", icon: PoultryIcon, activeIcon: PoultryIcon },    
  ];

  const { id } = useParams();
  const [active, setActive] = useState(false);

  const showCommoditiesMenu = () => {
    setActive(!active);
  };

  const container = useRef(null);

  function OutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setActive(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  OutsideClick(container);

  return (
    <Box ref={container} className="commodities-wrapper">
      <div className={active ? "commoditiesMenuWrapper active" : "commoditiesMenuWrapper"}>
        <div className="commoditiesBar">
          <div className="commoditiesBar_inner">
            <div className="arrowIcon">
              <Button sx={{ padding: "0px", zIndex: 1000 }} onClick={showCommoditiesMenu}>
                <ExpandCircleDownOutlinedIcon
                  style={{
                    color: "#fff",
                    rotate: "90deg",
                    zIndex: "1000",
                    cursor: "pointer",
                  }}
                  className={active ? "arrowSvg active" : "arrowSvg"}
                />
              </Button>
            </div>
            <div className="commoditiesBarTitle">
              <span> SELECT A FOOD COMMODITY <br /> TO VIEW DETAILED RESULTS</span>
            </div>
          </div>
        </div>
        <div className="commoditiesMenuInner">
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "column", md: "row" },
            }}
            className={active ? "commoditiesMenu active" : "commoditiesMenu"}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "repeat(1, 1fr)", sm: "repeat(1, 1fr)", md: "repeat(3, 1fr)" },
                margin: "10px",
              }}
            >
              {commodities.map((c) => {
                const normalized = c.name.replace(" ", "_").replace("/", "-").toLowerCase();
                return (
                  <ListItem
                    className="listItem"
                    sx={{ width: "auto", display: "inline-block" }}
                    key={normalized}
                    style={{ margin: "0" }}
                  >
                    <Link to={PageRoutes.COMMODITY_ROOT + normalized} onClick={showCommoditiesMenu}>
                      <Chip
                        avatar={
                          <Avatar
                            sx={{ background: "none !important" }}
                            alt={normalized}
                            src={id && id === normalized ? c.activeIcon : c.icon}
                          />
                        }
                        clickable
                        style={{
                          padding: "2px 16px",
                          margin: "0",
                          color: id && id === normalized ? "white" : "white",
                          borderColor: "#1F5C90",
                          backgroundColor: id && id === normalized ? "#1F5C90" : "transparent",
                        }}
                        variant={id && id === normalized ? "filled" : "outlined"}
                        label={c.name}
                      />
                    </Link>
                  </ListItem>
                );
              })}
            </Box>
          </Box>
        </div>
      </div>
    </Box>
  );
};

export default CommoditiesMenu;
